import { ProductResource } from '@df/catalog/product/product.resource';
import { Nexus } from '@tomandco/nexus-api-types';
import { BundleOption } from './bundle-option';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Subject } from 'rxjs';

export class BundleOptionValue {

    /**
     * Change notifier
     */
    readonly change$ = new Subject<void>();

    /**
     * Selection id
     */
    get id() {
        return this.data.selection_id;
    }

    /**
     * Boolean switch for option to be picked
     */
    get selected(): boolean {
        return this.option.isSelected(this.data.selection_id);
    }
    set selected(to: boolean) {
        this.option.setQty(this.data.selection_id, to ? this.data.qty || 1 : 0);
    }

    /**
     * Selected quantity
     */
    get qty(): number {
        return this.option.getQty(this.data.selection_id);
    }
    set qty(qty: number) {
        if (qty && !this.editableQty) {
            qty = this.data.qty || 1;
        }
        this.option.setQty(this.data.selection_id, qty);
    }

    get editableQty(): boolean {
        return !this.data.fixedQty;
    }

    /**
     * Product model
     */
    readonly product = this.productResource.get(this.data.id) as Product<IProductDataV3>;

    /**
     * Price getter
     */
    get price() {
        switch (this.data.price_type) {
            case 'fixed':
                return this.data.price;
        }
    }

    /**
     * Row price getter
     */
    get rowPrice() {
        return this.price * this.qty;
    }



    constructor(
        private option: BundleOption,
        private productResource: ProductResource,
        readonly data: Nexus.Lib.Catalog.Type.IProductDataBundleOptionChild
    ) {}
}
